import React from 'react'
import { useTranslate } from '../../contexts/TranslationContext'
import { Button } from './Button'

type HeurekaButtonProps = {
	id?: string
	link?: string
	variant?: | 'bordered'
	| 'naked'
	| 'nakedMore'
	| 'nakedIcon'
	| 'primary'
	| 'underlined'
	| 'white'
	| 'transparent'
	| 'underlinedGrey'
	| 'extraLarge'
}

export const HeurekaButton = React.memo(function HeurekaButton(props: HeurekaButtonProps) {
	const translate = useTranslate()

	return (
		<Button
			type={{
				variant: props.variant || 'primary',
				large: true
			}}
			label={translate('productIntroSummary.button.chooseEshop')}
			url={props.id ? `${props.link}#prehled/?haff=${props.id}&utm_medium=affiliate` : props.link}
			disabled={!props.link}
			dataTrixam={props.id}
			isTargetBlank
		/>
	)
})
